<template>
  <div class="material-icons">
    <span
      v-if="enableSpinButton(spinSelectedButtons, 'left')"
      class="material-icons-outlined"
      :style="{'color': spinControlIconsColor, 'font-size': size + 'px'}"
      @click="left"
    >navigate_before</span>
    <span
      class="material-icons-outlined"
      :style="{'color': spinControlIconsColor, 'font-size': size + 'px'}"
      @click="playOrPause"
    >{{ isPlay ? 'pause' : 'play_arrow' }}</span>
    <span
      v-if="enableSpinButton(spinSelectedButtons, 'right')"
      class="material-icons-outlined"
      :style="{'color': spinControlIconsColor, 'font-size': size + 'px'}"
      @click="right"
    >navigate_next</span>
    <span
      v-if="enableSpinButton(spinSelectedButtons, 'up')"
      class="material-icons-outlined"
      :style="{'color': spinControlIconsColor, 'font-size': size + 'px'}"
      @click="up"
    >keyboard_arrow_up</span>
    <span
      v-if="enableSpinButton(spinSelectedButtons, 'down')"
      class="material-icons-outlined"
      :style="{'color': spinControlIconsColor, 'font-size': size + 'px'}"
      @click="down"
    >keyboard_arrow_down</span>
    <span
      v-if="enableSpinButton(spinSelectedButtons, 'zoomin')"
      class="material-icons-outlined"
      :style="{'color': spinControlIconsColor, 'font-size': size + 'px'}"
      @click="zoomIn"
    >add</span>
    <span
      v-if="enableSpinButton(spinSelectedButtons, 'zoomout')"
      class="material-icons-outlined"
      :style="{'color': spinControlIconsColor, 'font-size': size + 'px'}"
      @click="zoomOut"
    >remove</span>
    <span
      v-if="enableSpinButton(spinSelectedButtons, 'fullscreen')"
      class="material-icons-outlined"
      :style="{'color': spinControlIconsColor, 'font-size': size + 'px'}"
      @click="fullScreen"
    >fullscreen</span>
    <span
      v-if="enableSpinButton(spinSelectedButtons, 'info')"
      class="material-icons-outlined"
      :style="{'color': spinControlIconsColor, 'font-size': size + 'px'}"
      @click="info"
    >info</span>
    <SpinInfo
      v-if="infoStatus"
      :text="infoText"
    />
  </div>
</template>

<script>
import { spinButtonControlMixin } from '@/mixins/spinButtonControl.mixin'
import SpinInfo from '@/widgets/common/SpinInfo'
import {mapGetters} from "vuex";

export default {
  name: 'SpinMaterialButtons',
  components: {
    SpinInfo
  },
  computed: {
    ...mapGetters({
      spinControlIconsColor: 'spinControl/spinControlIconsColor',
      size: 'spinControl/size'
    })
  },
  mixins: [spinButtonControlMixin]
}
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/icon?family=Material+Icons');
.material-icons {
  width: 100%;
  min-height: 80px;
  position: relative;
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  span {
    display: flex;
    width: 30px;
    height: 30px;
    justify-content: center;
    align-items: center;
    font-family: 'Material Icons';
    cursor: pointer;
    font-size: 30px;
  }
}
</style>
